import { useApiContext } from "@/setup/flexbiz-api-provider";
import { setToStorage } from "@/utils/localStorage";
import { useRouter } from "next/router";
import React from "react";

export default function GgLogin() {
  const context = useApiContext();
  const divRef = React.useRef(null);
  const router = useRouter();
  const [gsiScriptLoaded, setGsiScriptLoaded] = React.useState(false);

  const goBack = () => {
    router.back();
    return null;
  };

  const responseGoogle = async (response) => {
    // const data = jwt_decode(response);
    // if (data.error) {
    //   return;
    // }

    const urlProfile = `${process.env.server_url}/createUser/google?id_app=${process.env.id_app}&group_id=${process.env.group_id}&id_token=${response}`;
    try {
      // let profile = await apis.asyncGet(urlGetProfile);
      const profile = JSON.parse(await context.apis.asyncGet(urlProfile));
      if (profile && profile.access_token) {
        setToStorage("updateInfo", true);
        setToStorage("token", profile.access_token);
        // localStorage.setItem("updateInfo", true);
        // localStorage.setItem("token", profile.access_token);
        goBack();
      }
    } catch (error) {
      console.log("error", error);
      console.error({
        message: "Lỗi responseGoogle",
      });
    }
  };

  React.useEffect(() => {
    const initializeGsi = () => {
      // Typescript will complain about window.google
      // Add types to your `react-app-env.d.ts` or //@ts-ignore it.
      if (!window.google || gsiScriptLoaded) return;

      setGsiScriptLoaded(true);
      window.google.accounts.id.initialize({
        client_id: process.env.google_client_id,
        callback: handleCredentialResponse,
      });
      window.google.accounts.id.renderButton(
        divRef.current,
        {
          theme: "outline",
          size: "large",
          shape: "circle",
          text: "signin_with",
          width: 300,
          logo_alignment: "left",
        } // customization attributes
      );
    };

    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.onload = initializeGsi;
    script.async = true;
    script.id = "google-client-script";
    document.querySelector("body")?.appendChild(script);

    return () => {
      // Cleanup function that runs when component unmounts
      window.google?.accounts.id.cancel();
      document.getElementById("google-client-script")?.remove();
    };
  }, [handleCredentialResponse]);

  async function handleCredentialResponse(response) {
    // console.log("response", response);
    // const responsePayload = jwt_decode(response.credential);
    responseGoogle(response.credential);
  }

  return process.env.google_client_id && <div ref={divRef} />;
}
